module.exports = __webpack_public_path__ + "static/img/9.30109ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/people/9.png
// module id = zQ+8
// module chunks = 1